export default (amount: number): string => `${amount.toLocaleString('ja-JP')}円`
